import React, {useContext, useState} from "react";
import {DateObject} from "react-multi-date-picker";
import AuthContext from "../../context/AuthContext";
import {Link} from "react-router-dom";
import useBookingService from "../../api/services/useBookingService";
import useBookable from "../../hooks/useBookable";
import useFunction from "../../hooks/useFunction";
import usePrice from "../../hooks/usePrice";
import Loading from "../Loading/Loading";
import Button from "../Button/Button";
import swal from "sweetalert";
import bookingPaymentTimingEnum from "../../data/bookingPaymentTimingEnum";

const BookingPayAfterAcceptButtons = ({booking, user, onChangeAcceptTerms}) => {

  return (
    <>
      {booking.payment_timing === 'after' && booking.active_user_pays === true &&
        <label htmlFor="terms_accepted_active_user_pays_at"
               onClick={() => onChangeAcceptTerms('terms_accepted_active_user_pays_at')}>
          <div className="row">
            <div className="col">
              <input
                name="terms_accepted_active_user_pays_at"
                checked={!!booking.terms_accepted_active_user_pays_at}
                type="checkbox"
              />
            </div>
            <div className="col">
              <div>
                Ik, {user.first_name} {user.last_name}, handel namens mijn organisatie&nbsp;
                '{user.active_company.legal_name}'. Ik ga akkoord met de&nbsp;
                <a href="/voorwaarden-voor-achteraf-betalen/" target="_blank">voorwaarden voor achteraf
                  betalen</a>.&nbsp;
                Ik begrijp dat mijn organisatie het totaal bedrag genoemd op deze pagina&nbsp;
                via Standplaats.nl BV achteraf zal voldoen. Standplaats.nl zal het bedrag direct overmaken&nbsp;
                aan de ontvangende organisatie nadat betaling door mijn organisatie is voldaan.
              </div>
            </div>
          </div>
        </label>
      }
      {booking.payment_timing === 'after' && booking.active_user_gets_paid === true &&
        <label htmlFor="terms_accepted_active_user_gets_paid_at"
               onClick={() => onChangeAcceptTerms('terms_accepted_active_user_gets_paid_at')}>
          <div className="row">
            <div className="col">
              <input
                name="terms_accepted_active_user_gets_paid_at"
                onChange={() => !booking.terms_accepted_active_user_gets_paid_at}
                checked={!!booking.terms_accepted_active_user_gets_paid_at}
                type="checkbox"
              />
            </div>
            <div className="col">
              <div>
                Ik, {user.first_name} {user.last_name}, handel namens mijn organisatie&nbsp;
                '{user.active_company.legal_name}'. Ik ga akkoord met de&nbsp;
                <a href="/voorwaarden-voor-achteraf-betalen/" target="_blank">voorwaarden voor achteraf
                  betalen</a>.&nbsp;
                Ik begrijp dat mijn organisatie het totaal bedrag genoemd op deze pagina&nbsp;
                via Standplaats.nl BV pas zal ontvangen nadat de betalende organisatie de betaling heeft voldaan.
              </div>
            </div>
          </div>
        </label>
      }
    </>
  )
}


const BookingOverview = (props) => {

  const {
    className,
    save,
    formData,
    wizard,
    form,
  } = props

  const {
    formatPrice,
    formatPercent,
    countBookingPriceTypePositive,
    countBookingPriceTypeNegative,
    countBookingPriceTypeNegotiate,
    countBookingPriceTypeRelative,
    getBookingTotalPricePositive,
    getBookingTotalPriceNegative,
    getBookingTotalAmountNegotiate,
    getBookingTotalFormattedPercentagesRelative,
    getLatestNegotiationTotalPrice,
    // getBookingPriceTotalWithoutFee,
    getBookable,
    addBookingFee,
    // isPositivePrice:isPositivePriceFunc,
    transactionFee,
  } = usePrice()
  const booking = formData.model;
  const bookable = getBookable(booking)
  const {isSpotGroup, isStand} = useBookable()
  const {userAction} = useBookingService()
  const {user} = useContext(AuthContext)
  const {dateTime} = useFunction()
  const [isLoading, setIsLoading] = useState(false)
  const countTypePositive = countBookingPriceTypePositive(booking, bookable)
  const countTypeNegative = countBookingPriceTypeNegative(booking, bookable)
  const countTypeNegotiate = countBookingPriceTypeNegotiate(booking, bookable)
  const countTypeRelative = countBookingPriceTypeRelative(booking, bookable)
  // const isPositivePrice = isPositivePriceFunc(booking, bookable)
  let hasOpenNegotiation = false


  const onChangeAcceptTerms = (key) => {
    const toggleableKeys = [
      'requested_general_terms_accepted_at',
      'terms_accepted_active_user_pays_at',
      'terms_accepted_active_user_gets_paid_at',
      'requested_terms_accepted_at'
    ];

    // Toggle timestamp zodat checked={!!...} direct klopt
    if (toggleableKeys.includes(key)) {
      booking[key] = booking[key] ? null : new Date().toISOString();
      form.save(false); // force rerender
    }

    // Welke extra voorwaarden zijn verplicht?
    const needPayer = booking.payment_timing === 'after' && !!booking.active_user_pays;
    const needReceiver = booking.payment_timing === 'after' && !!booking.active_user_gets_paid;

    // Alle vereiste vinkjes gezet?
    const allRequestingChecked =
      booking.direction === 'requesting' &&
      !!booking.requested_general_terms_accepted_at &&
      (!needPayer || !!booking.terms_accepted_active_user_pays_at) &&
      (!needReceiver || !!booking.terms_accepted_active_user_gets_paid_at);

    const allReceivingChecked =
      booking.direction === 'receiving' &&
      (!needPayer || !!booking.terms_accepted_active_user_pays_at) &&
      (!needReceiver || !!booking.terms_accepted_active_user_gets_paid_at);

    // Accept-knop expliciet (laat swal altijd zien als er op de knop is geklikt)
    const explicitAcceptRequested = key === 'requested_terms_accepted_at';
    const explicitAcceptReceived = key === 'received_terms_accepted_at';

    // REQUESTING – open swal zodra alle vereiste vinkjes gezet zijn, of bij expliciete accept
    if (allRequestingChecked || explicitAcceptRequested) {
      swal({
        title: 'Accepteren?',
        text: 'Accepteer de boeking, de algemene voorwaarden, de boekingsvoorwaarden' +
          (booking.payment_timing === 'after' ? ' en de voorwaarden voor achteraf betalen?' : '?'),
        icon: '',
        closeOnClickOutside: false,
        closeOnEsc: false,
        buttons: {
          cancel: {
            text: 'Nee',
            value: null,
            visible: true,
            className: 'btn-color-grey btn-size-m',
            closeModal: true,
          },
          confirm: {
            text: 'Accepteer',
            value: true,
            visible: true,
            className: 'btn-color-green btn-size-m',
            closeModal: true,
          }
        }
      }).then((result) => {
        if (result) {
          window.scroll(0, 0);
          setIsLoading(true);
          userAction(
            () => {
              booking.requested_terms_accepted_at = 'just-now';
              save(false);
              setIsLoading(false);
              wizard.nextStep();
            },
            (errors) => {
            },
            booking.id,
            {action: 'accept'},
          );
        } else {
          toggleableKeys.map((key) => booking[key] = null);
          form.save(false);
        }
      });
      return;
    }

    // RECEIVING – open swal zodra alle vereiste vinkjes gezet zijn, of bij expliciete accept
    if (allReceivingChecked || explicitAcceptReceived) {
      swal({
        title: 'Accepteer boekingsaanvraag?',
        text: 'Accepteer de boeking, de algemene voorwaarden, de boekingsvoorwaarden' +
          (booking.payment_timing === 'after' ? ' en de voorwaarden voor achteraf betalen?' : '?'),
        icon: '',
        closeOnClickOutside: false,
        closeOnEsc: false,
        buttons: {
          cancel: {
            text: 'Nee',
            value: null,
            visible: true,
            className: 'btn-color-grey btn-size-m',
            closeModal: true,
          },
          confirm: {
            text: 'Accepteer',
            value: true,
            visible: true,
            className: 'btn-color-green btn-size-m',
            closeModal: true,
          }
        }
      }).then((result) => {
        if (result) {
          window.scroll(0, 0);
          setIsLoading(true);
          userAction(
            () => {
              booking.received_terms_accepted_at = 'just-now';
              save(false);
              setIsLoading(false);
              wizard.nextStep();
            },
            (errors) => {
            },
            booking.id,
            {action: 'accept'},
          );
        } else {
          toggleableKeys.map((key) => booking[key] = null);
          form.save(false);
        }
      });
    }
  };


  return (
    <>
      {isLoading ?
        <Loading/>
        :
        <div className={className + 'booking-overview '}>
          <div className="overview">

            {booking.direction === 'requesting' &&
              <>
                <h1>Reservering aanvragen, id: {booking.booking_number}</h1>
                <p>Je staat op het punt om een reserverings-<u>aanvraag</u> te doen. <strong>De aanvraag is
                  altijd <u>geheel</u> gratis. </strong>Wanneer jouw aanvraag goedkeurd wordt, ontvang je een
                  betaalverzoek. Als de aanvraag wordt afgewezen, worden er geen kosten in rekening gebracht.</p>
              </>
            }

            {booking.direction === 'receiving' &&
              <>
                <h1>Reservering accepteren, id: {booking.booking_number}</h1>
                <p>Je staat op het punt om een reserverings-<u>aanvraag</u> te accepteren.</p>
              </>
            }

            <h3>Controlleer de onderstaande gegevens:</h3>
            {!isSpotGroup(bookable) &&
              <h4>
                <strong>Aanvrager </strong>{(booking.spot_group) ? 'locatie' : 'Account/organisatie (zonder locatie profiel)'}
              </h4>
            }
            {!isStand(bookable) &&
              <h4><strong>Aanvrager </strong>Stand, Truck of Act</h4>
            }
            <div className="table">

              {isSpotGroup(bookable) &&
                <div className="row">
                  <div className="col">Stand of truck:</div>
                  <div className="col">
                    {booking.stand
                      ? <strong>{booking.stand.label}</strong>
                      : <strong className="color-red">GEEN STAND: <Link
                        to={wizard.pathname + '/select_stand'}>SELECTEER STAND</Link></strong>
                    }
                  </div>
                </div>
              }

              {isStand(bookable) && booking.spot_group &&
                <div className="row">
                  <div className="col">Locatie:</div>
                  <div className="col">
                    {booking.spot_group
                      ? <strong>{booking.spot_group.label}</strong>
                      : <strong>Deze boeking is op een onbekende locatie</strong>
                    }
                  </div>
                </div>
              }
              <div className="row">
                <div className="col">
                  {booking.requested_by_company.type === 'commercial' && 'Bedrijf: '}
                  {booking.requested_by_company.type === 'non-official' && 'Account: '}
                  {booking.requested_by_company.type === 'public' && 'Organisatie: '}
                  {booking.requested_by_company.type === 'non-profit' && 'Non-profit: '}
                </div>
                <div className="col">{booking.requested_by_company.legal_name}</div>
              </div>
              <div className="row">
                <div className="col">Gebruiker:</div>
                <div className="col">{booking.requested_by_user.first_name} {booking.requested_by_user.last_name}</div>
              </div>

            </div>
            <h4><strong>Ontvanger aanvraag </strong>{(isSpotGroup(bookable)) ? 'Locatie' : 'stand of truck'}:</h4>
            <div className="table">

              {isSpotGroup(bookable) &&
                <>
                  <div className="row">
                    <div className="col">Locatie naam:</div>
                    <div
                      className="col">{booking.spot_group.label}</div>
                  </div>
                  <div className="row">
                    <div className="col">Account/organisaties naam:</div>
                    <div
                      className="col">{booking.spot_group.company.legal_name}</div>
                  </div>
                </>
              }
              {isStand(bookable) &&
                <>
                  <div className="row">
                    <div className="col">Stand/Truck/Act:</div>
                    <div
                      className="col">{booking.stand.label}</div>
                  </div>
                  <div className="row">
                    <div className="col">Account/organisatie naam:</div>
                    <div
                      className="col">{booking.stand.company.legal_name}</div>
                  </div>
                </>
              }

            </div>
            <h4>Details:</h4>
            <div className="table">
              {isSpotGroup(bookable) &&
                <div className="row">
                  {bookable.show_spots_as_list ?
                    <>
                      <div className="col">Aantal meter:</div>
                      <div
                        className="col">{booking.spots.length} x {bookable.spots_in_list_length} = {booking.spots.length * bookable.spots_in_list_length} meter
                      </div>
                    </>
                    :
                    <>
                      <div className="col">Aantal spots:</div>
                      <div className="col">{booking.spots.length}</div>
                    </>
                  }
                </div>
              }
              <div className="row">
                <div className="col">Aantal dagen:</div>
                <div className="col">{booking.date_ranges.length}</div>
              </div>

              <div className="row">
                <div className="col">Standplaats Namen/id's:</div>
                <div className="col">
                  {booking.spots && booking.spots.map((spot, i) => {
                    if (spot.spot_cluster) {
                      return (<span key={i}>{spot.spot_cluster.label}: {booking.spots.length - 1 !== i && ', '}</span>)
                    } else {
                      return (<span key={i}>{spot.label}{booking.spots.length - 1 !== i && ', '}</span>)
                    }
                  })}
                </div>
              </div>
              <div className="row">
                <div className="col">Data:</div>
                <div className="col">
                  {booking.date_ranges.map((date, i) => {
                    // return (<span key={i}>{Moment(new Date(date.toString())).format('D MMMM YYYY')}, </span>
                    return (<span key={i}>{new DateObject(date.start_date).format("D MMMM YYYY")}, </span>
                    )
                  })}
                </div>
              </div>
            </div>

            <h4>Prijzen:</h4>
            <div className="table">
              <div className="row">
                <div className="col">Betaalmoment:</div>
                <div className="col">{bookingPaymentTimingEnum.getLabel(booking.payment_timing)}</div>
              </div>
            </div>
            <div className="table">
              {isSpotGroup(bookable) &&
                <div className="row">
                  <div
                    className="col">{(booking.spots.length === 1) ? booking.spots.length + ' standplaats' : booking.spots.length + ' standplaatsen'}:
                  </div>
                </div>
              }
              {!!countTypePositive &&
                <div className="row">
                  <div className="col">
                    {countTypePositive}, Totaal te betalen
                  </div>
                  <div className="col">
                    {formatPrice(addBookingFee(getBookingTotalPricePositive(booking, bookable).price))}
                  </div>
                </div>
              }
              {!!countTypeNegative &&
                <div className="row">
                  <div className="col">
                    {countTypeNegative}, Totaal te ontvangen
                  </div>
                  <div className="col">
                    {formatPrice(getBookingTotalPriceNegative(booking, bookable).price)}
                  </div>
                </div>
              }
              {isSpotGroup(bookable) && !!countTypeNegotiate &&
                <div className="row">
                  <div className="col">
                    {countTypeNegotiate}, standplaatsen n.o.t.k.
                  </div>
                  <div className="col">
                    {getBookingTotalAmountNegotiate(bookable, booking)} Totaal: {formatPrice(getLatestNegotiationTotalPrice(booking) * booking.date_ranges.length)}
                    {booking.prices.spots.map((spot, i) => {
                      if (spot.price_type === 'negotiate') {
                        if (spot.offers && Array.isArray(spot.offers) && spot.offers.length > 0) {
                          const offer = spot.offers[0]
                          return (
                            <p key={i}>Laatste
                              bieding: {booking.direction === 'receiving' && offer.type === 'positive' && 'Verdien'}
                              {booking.direction === 'requesting' && offer.type === 'positive' && 'Betaal'}
                              {booking.direction === 'receiving' && offer.type === 'negative' && 'Betaal'}
                              {booking.direction === 'requesting' && offer.type === 'negative' && 'Verdien'}
                              {offer.type === 'relative'
                                ? <>Omzet {formatPercent(offer.value)}</>
                                :
                                <>
                                  {offer.type === 'negotiate'
                                    ? <>Onderhandelen</>
                                    : <>{formatPrice(offer.value * booking.date_ranges.length)} ({formatPrice(offer.value)} p/d)</>
                                  }
                                </>
                              }
                            </p>
                          )
                        } else {
                          hasOpenNegotiation = true
                        }
                      }
                    })}
                  </div>
                </div>
              }
              {isStand(bookable) && !!countTypeNegotiate &&
                <div className="row">
                  <div className="col">
                    {countTypeNegotiate}, stand/truck/act n.o.t.k.
                  </div>
                  <div className="col">
                    {getBookingTotalAmountNegotiate(bookable, booking)} Totaal: {formatPrice(getLatestNegotiationTotalPrice(booking) * booking.date_ranges.length)}

                    {[1].map((item, i) => {
                      const stand = booking.prices.stand
                      if (stand.offers && Array.isArray(stand.offers) && stand.offers.length > 0) {
                        const offer = stand.offers[0]
                        return (
                          <p key={i}>Laatste
                            bieding: {booking.direction === 'receiving' && offer.type === 'positive' && 'Verdien'}
                            {booking.direction === 'requesting' && offer.type === 'positive' && 'Betaal'}
                            {booking.direction === 'receiving' && offer.type === 'negative' && 'Betaal'}
                            {booking.direction === 'requesting' && offer.type === 'negative' && 'Verdien'}
                            {offer.type === 'relative'
                              ? <>Omzet {formatPercent(offer.value)}</>
                              :
                              <>
                                {offer.type === 'negotiate'
                                  ? <>Onderhandelen</>
                                  : <>{formatPrice(offer.value * booking.date_ranges.length)} ({formatPrice(offer.value)} p/d)</>
                                }
                              </>
                            }
                          </p>
                        )
                      } else {
                        hasOpenNegotiation = true
                      }
                    })
                    }
                  </div>
                </div>
              }

              {!!countTypeRelative &&
                <div className="row">
                  <div className="col">
                    {countTypeRelative}, Totaal op basis van omzet
                  </div>
                  <div className="col">
                    {getBookingTotalFormattedPercentagesRelative(booking, bookable)} ***
                  </div>
                </div>
              }
              <hr/>
              <>
                {booking.direction === 'receiving' &&
                  <div className="field price">
                    <h4>{booking.prices.totals.receiving.total.get ? 'Inkomsten:' : 'Uitgaven:'}</h4>


                    {booking.prices.totals.receiving.get.rent
                      ?
                      <div className="row">
                        <div className="col">Verhuur inkomsten:</div>
                        <div className="col">{formatPrice(booking.prices.totals.receiving.get.rent)}</div>
                      </div>
                      :
                      <div className="row">
                        <div className="col">Huur kosten:</div>
                        <div className="col">{formatPrice(booking.prices.totals.receiving.pay.rent)}</div>
                      </div>
                    }


                    <div className="row">
                      <div className="col">Opties inkomsten:</div>
                      <div className="col">{formatPrice(booking.prices.totals.receiving.get.options)}</div>
                    </div>

                    {booking.prices.totals.receiving.total.get
                      ?
                      <div className="row">
                        <div className="col"><strong>Totale inkomsten:</strong></div>
                        <div className="col"><strong>{formatPrice(booking.prices.totals.receiving.total.get)}</strong>
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col"><strong>Totale kosten:</strong></div>
                        <div className="col"><strong>{formatPrice(booking.prices.totals.receiving.total.pay)}</strong>
                        </div>
                      </div>
                    }
                  </div>
                }
                {booking.direction === 'requesting' &&
                  <div className="field price">
                    <h4>{booking.prices.totals.requesting.total.get ? 'Inkomsten:' : 'Uitgaven:'}</h4>

                    {booking.prices.totals.requesting.get.rent
                      ?
                      <div className="row">
                        <div className="col">Verhuur inkomsten:</div>
                        <div className="col">{formatPrice(booking.prices.totals.requesting.get.rent)}</div>
                      </div>
                      :
                      <div className="row">
                        <div className="col">Huur kosten:</div>
                        <div className="col">{formatPrice(booking.prices.totals.requesting.pay.rent)}</div>
                      </div>
                    }

                    <div className="row">
                      <div className="col">Opties kosten:</div>
                      <div className="col">{formatPrice(booking.prices.totals.requesting.pay.options)}</div>
                    </div>

                    <div className="row">
                      <div
                        className="col">{(booking.prices.totals.requesting.pay.fees >= transactionFee) ? 'Boekingskosten:' : 'Fee & Boekingskosten:'}</div>
                      <div className="col">{formatPrice(booking.prices.totals.requesting.pay.fees)}</div>
                    </div>

                    {booking.prices.totals.requesting.total.get
                      ?
                      <div className="row">
                        <div className="col"><strong>Totale inkomsten:</strong></div>
                        <div className="col"><strong>{formatPrice(booking.prices.totals.requesting.total.get)}</strong>
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col"><strong>Totale kosten:</strong></div>
                        <div className="col"><strong>{formatPrice(booking.prices.totals.requesting.total.pay)}</strong>
                        </div>
                      </div>
                    }
                  </div>
                }


              </>
            </div>
            <p>* Alle prijzen zijn EXCL. BTW</p>
            {
              !!countTypeNegotiate && hasOpenNegotiation &&
              <p>** N.O.T.K. moeten nog overeengekomen worden en zijn hier nu niet weergegeven.</p>
            }
            {
              !!countTypeRelative &&
              <p>*** Prijzen op basis van omzet worden achteraf verrekend, en zijn hier nu niet weergegeven.</p>
            }
          </div>
          <div className="terms">

            {booking.direction === 'requesting' &&
              <div className="row">
                {isSpotGroup(bookable) ?
                  <>
                    {booking.spot_group && booking.spot_group.booking_conditions &&
                      <div className="owner-terms">
                        <h3>Aanvullende Voorwaarden van de locatie
                          eigenaar: {booking.spot_group.company.legal_name}</h3>
                        {booking.spot_group.booking_conditions && booking.spot_group.booking_conditions.split('\n').map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            <br/>
                          </React.Fragment>
                        ))}
                      </div>
                    }
                  </>
                  :
                  <>
                    {booking.stand && booking.stand.booking_conditions &&
                      <div className="owner-terms">

                        <h3>Aanvullende Voorwaarden van de stand of truck
                          eigenaar: {booking.stand.company.legal_name}</h3>
                        {booking.stand.booking_conditions && booking.stand.booking_conditions.split('\n').map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            <br/>
                          </React.Fragment>
                        ))}
                      </div>
                    }
                  </>
                }
              </div>
            }
            {booking.direction === 'requesting' &&
              <>
                {typeof booking.requested_terms_accepted_at === 'string'
                  ? <>Aangevraagd &
                    ondertekend: {booking.requested_terms_accepted_at === 'just-now' ? 'zojuist' : dateTime(booking.requested_terms_accepted_at)}</>
                  :
                  <>

                    <label htmlFor="requested_general_terms_accepted_at"
                           onClick={() => onChangeAcceptTerms('requested_general_terms_accepted_at')}>
                      <div className="row">
                        <div className="col">
                          <input
                            name="requested_general_terms_accepted_at"
                            checked={!!booking.requested_general_terms_accepted_at}
                            type="checkbox"
                          />
                        </div>
                        <div className="col">
                          Ik, {user.first_name} {user.last_name}, verklaar hierbij akkoord te gaan met de&nbsp;
                          <a href="/algemene-voorwaarden/" target="_blank">algemene voorwaarden</a> en de&nbsp;
                          voorwaarden van de {(isSpotGroup(bookable)) ? 'locatie' : 'stand of truck'} eigenaar,
                          zoals&nbsp;
                          hierboven op deze pagina vermeld. Ik verklaar tevens bevoegd te zijn om namens de
                          aanvragende&nbsp;
                          organisatie '{user.active_company.legal_name}' deze boekingsaanvraag te doen.&nbsp;
                          Indien de ontvangende organisatie&nbsp;
                          '{(isSpotGroup(bookable)) ? booking.spot_group.label : booking.stand.label}'&nbsp;
                          deze boekingsaanvraag accepteert, zal ik ervoor zorgdragen dat de aanvragende
                          organisatie&nbsp;
                          '{user.active_company.legal_name}' het totaalbedrag tijdig voldoet aan Standplaats.nl BV&nbsp;
                          via dit platform.
                        </div>
                      </div>
                    </label>
                    <BookingPayAfterAcceptButtons
                      booking={booking}
                      user={user}
                      onChangeAcceptTerms={onChangeAcceptTerms}
                    />
                  </>
                }
              </>
            }
            {booking.direction === 'receiving' &&
              <>
                {typeof booking.received_terms_accepted_at === 'string'
                  ? <>Aangevraagd &
                    ondertekend: {booking.received_terms_accepted_at === 'just-now' ? 'zojuist' : dateTime(booking.received_terms_accepted_at)}</>
                  : <>

                    <div className="row">
                      <BookingPayAfterAcceptButtons
                        booking={booking}
                        user={user}
                        onChangeAcceptTerms={onChangeAcceptTerms}
                      />
                    </div>
                    <div className="row">
                      <Button
                        label="Accepteer boeking"
                        onClick={() => onChangeAcceptTerms('received_terms_accepted_at')}
                      />
                    </div>
                  </>
                }
              </>
            }

          </div>
        </div>
      }
    </>
  )
}

export default BookingOverview
